export enum LegalDocsState {
  Loading,
  Loaded,
  Error,
}
